import { render, staticRenderFns } from "./FourCornersCard.vue?vue&type=template&id=d80f8b14&"
import script from "./FourCornersCard.vue?vue&type=script&lang=js&"
export * from "./FourCornersCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports